
import React from 'react';
import { TextBlockView } from '@plone/volto-slate/blocks/Text';

/* STYLE */
import '@redturtle/volto-rt-blocks/components/Blocks/Text/Text.less';

const View = (props) => {
  return (
    <div className={`slate ${props.className}`}>
      <TextBlockView {...props} />
    </div>
  );
};

export default View;
